var Toast = function () {
  function remove(element) {
    if (element && element.parentNode) {
      element.parentNode.removeChild(element);
    }
  }




  var body = document.querySelector('body')

  var id = 0

  function showToast(text, duration,callback) {
    duration = duration || 1000;
    var newToast = document.createElement('div');
    newToast.classList.add('toast', 'toast-' + id)
    newToast.innerHTML = `<p>${text}</p>`
    id += 1;
    body.appendChild(newToast);
    newToast.classList.add("in");
    setTimeout(function () {
      newToast.classList.add("out");
    }, duration);
    setTimeout(function () {
      remove(newToast)
      if(callback){
        callback()
      }
    }, duration + 250);
  }

  return {
    showToast: showToast
  };
}()

window.Toast = Toast

export default {
  install(Vue) {
    Vue.prototype.$toast = Toast
  }
}

export {Toast}
